import { Flex, Heading, Skeleton, Table, TableContainer, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { TaskTypeProps } from "../../../services/taskTypeService/taskTypeService.interface";
import { BaseResponseMetadataProps } from "../../../services/base.interface";
import TableItem from "./TableItem";
import ReactPaginate from "react-paginate";

export interface TableTaskTypeV2Props {
  data: TaskTypeProps[]
  metadata: BaseResponseMetadataProps
  isLoading: boolean
  handlePagination: (page: number) => void
}

export default function TableTaskTypeV2(props: TableTaskTypeV2Props) {
  const { data, metadata, isLoading, handlePagination } = props

  const { t } = useTranslation()

  const tableHeaders: string[] = [
    t("daftar_anggota_tabel_no"),
    t("tipe_tugas_tabel_kode_tipe_tugas"),
    t("tipe_tugas_tabel_nama_tugas"),
    t("tipe_tugas_tabel_status"),
    t("tipe_tugas_access"),
    t("tipe_tugas_before_clock_in"),
    t("tipe_tugas_before_clock_out"),
    t('tipe_tugas_tabel_download_template'),
  ]

  return (
    <Flex direction='column'>
      <TableContainer
        overflowX="auto"
        overflowY="auto"
        maxWidth="calc(100vw - var(--sidebarWidth) - 48px)"
      >
        <Table variant="j-simple">
          <Thead>
            <Tr>
              {tableHeaders.map((header: any, headerIndex: number) => (
                <Th key={headerIndex}>
                  {header}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data?.map((taskType, taskTypeIndex) => {
              return (
                <TableItem key={taskTypeIndex} taskType={taskType} rowFrom={metadata.from} rowIndex={taskTypeIndex} />
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <Flex
          padding='2px 16px 22px'
          mt='16px'
          bg='surfacePlus4'
          align='end'
          justifyContent='space-between'
          rounded='0px 0px 16px 16px'
      >
        {
          isLoading
          ? <Skeleton height='20px' width='300px' mt='20px' />
          : <Heading size='chakra_label_large' color='onSurfaceVariant' p='5px'>
              {t('tipe_tugas_tabel_informasi_halaman', { from: metadata?.from, to: metadata?.to, total: metadata?.total })}
            </Heading>
        }
        {
          isLoading
            ? <Skeleton height='20px' width='300px' mt='20px' />
            : <ReactPaginate
                pageCount={metadata?.last_page}
                pageRangeDisplayed={10}
                breakLabel="..."
                previousLabel={`< ${t('bulletin_table_footer_prev')}`}
                nextLabel={`${t('bulletin_table_footer_next')} >`}
                onPageChange={(e) => {
                    if (metadata?.current_page === Number(e.selected + 1)) return
                    handlePagination(Number(e.selected) + 1)
                }}
                containerClassName="react-paginate-pagination"
                pageLinkClassName="react-paginate-page-item"
                breakLinkClassName="react-paginate-page-item"
                previousLinkClassName="react-paginate-page-item-previous"
                nextLinkClassName="react-paginate-page-item-next"
                activeClassName="react-paginate-page-item-active"
                initialPage={metadata?.current_page ? Number(metadata?.current_page - 1) : 0}
              />
        }
      </Flex>
    </Flex>
  )
}
